export default __webpack_public_path__ + "static/media/gallery_00.2a8cf526.jpg";